// @ts-check

import { get, getAll } from "../utilities/querySelector";

const sections = getAll( '[data-specs]' );

sections.forEach( section => {
    const next = get( '[data-specs-next]', section );
    const prev = get( '[data-specs-prev]', section );
    const slider = get( '[data-specs-slider]', section );
    const slides = getAll( '[data-specs-slide]', section );

    if ( !next || !prev || !slider || !slides ) return;

    next.addEventListener( 'click', () => navigate( 'next' ) );
    prev.addEventListener( 'click', () => navigate( 'prev' ) );

    const observer = new IntersectionObserver( observerHandler, {
        root: slider,
        threshold: 0.95
    } );
    slides.forEach( slide => observer.observe( slide ) );

    section.classList.add( 'hut-specs--initialized' );

    // setSliderStates();
    // slider.addEventListener( 'scrollend', setSliderStates );

    /**
     * @param {'next' | 'prev'} dir
     *
     * @return void
     */
    function navigate( dir ) {
        if ( dir === 'next' ) {
            const slideAmount = getNextInactiveSlide().offsetLeft - slider.offsetLeft;
            slider.scrollTo( slideAmount, 0 );
            slider.scrollLeft = slideAmount;
        } else if ( dir === 'prev' ) {
            const slideAmount = getPrevInactiveSlide().offsetLeft - slider.offsetLeft;
            slider.scrollTo( slideAmount, 0 );
        }
    }

    /**
{     * @param {IntersectionObserverEntry[]} entries
}     *
     * @return void
     */
    function observerHandler( entries ) {
        entries.forEach( entry => {
            if ( entry.isIntersecting ) {
                entry.target.classList.add( 'visible' );
            } else {
                entry.target.classList.remove( 'visible' );
            }
            setSliderStates();
        } );
    }

    function getNextInactiveSlide() {
        return get( '[data-specs-slide].visible + [data-specs-slide]', slider );
    }

    function getPrevInactiveSlide() {
        return get( '[data-specs-slide].visible' )?.previousElementSibling;
    }


    // Maybe check instead if there is a first/last child that is active

    function setSliderStates() {
        const firstSlide = get( '[data-specs-slide]', slider );
        const lastSlide = get( '[data-specs-slide]:last-child', slider );

        requestAnimationFrame( () => {
            if ( lastSlide.classList.contains( 'visible' ) ) {
                next.disabled = true;
            } else {
                next.disabled = false;
            }

            if ( firstSlide.classList.contains( 'visible' ) ) {
                prev.disabled = true;
            } else {
                prev.disabled = false;
            }

        } );

    }
} );